<script setup lang="ts">
const { searchKeyword, isLoading, legalAreaFacetOptions, legalAreaSelected, toggleLegalArea, searchLegalArea } = useJournalFilters()
</script>

<template>
  <aside aria-label="Filtervalg" class="flex flex-col gap-m w-[369px] pt-l">
    <div class="flex flex-col gap-s">
      <span aria-hidden="true" class="title-s font-semibold">
        Filtrer på tidsskrift
      </span>
      <FormSearchInput
        id="journal-title-filter"
        v-model="searchKeyword"
        resettable
        shape="square"
        size="medium"
        label="Filtrer på tidsskrift"
      />
    </div>

    <FilterSkeleton v-if="isLoading" />

    <div v-if="legalAreaFacetOptions.length" class="flex flex-col gap-s">
      <span class="text-small font-bold">Rettsområde</span>
      <FilterFacetList
        v-model:search="searchLegalArea"
        class="gap-s"
        label="Rettsområde"
        name="journalLegalArea"
        expand-noun="rettsområder"
        :options="legalAreaFacetOptions"
        :selected="legalAreaSelected"
        :toggle="toggleLegalArea"
      />
    </div>
  </aside>
</template>